import { SetStateAction, useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { TEN_MINUTES_IN_MS, THREE_DAYS_IN_MS } from '../constants';
import { GeocoderReturnable } from '../api-utils/geocode';

const rqOptions = {
    cacheTime: THREE_DAYS_IN_MS,
    staleTime: TEN_MINUTES_IN_MS,
};

const useGeoByAddress = (): {
    data: GeocoderReturnable | null;
    fetchGeo: (value: string) => void;
    status: 'idle' | 'error' | 'loading' | 'success'
} => {
    const [address, setAddress] = useState<string>('');
    const { data, status } = useQuery<GeocoderReturnable | null>(
        ['geo-by-address', address],
        async ({ queryKey }) => {
            const { 1: address } = queryKey;
            if (!address) {
                return {};
            }
            const apiUrl = `/api/geocode?address=${address as string}`;
            return (await fetch(apiUrl)).json();
        },
        rqOptions,
    );
    const fetchGeo = useCallback((value: SetStateAction<string>) => {
        setAddress(value);
    }, []);

    return { data: data || null, status, fetchGeo };
};

export default useGeoByAddress;
